import { useEffect } from 'react';
import { css } from '@emotion/react';
import { FlexStack } from '~/components/atomic';
import { GroupChatCard } from '~/components/atomic/Skeleton';
import { useGetGroupChatListQuery } from '~/features/chatRoom';
import { useIntersectionObserver } from '~/hooks';
import { makeIndexArray } from '~/utils';
import GroupChatItem from './GroupChatItem/GroupChatItem';
import { GroupChatType } from './GroupChatSection';

export default function GroupChatList({
  groupChatType,
}: {
  groupChatType: GroupChatType;
}) {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });

  const {
    data: groupChatListData,
    fetchNextPage,
    isFetchingNextPage,
  } = useGetGroupChatListQuery({
    type: groupChatType,
    query: '',
  });

  useEffect(() => {
    if (isIntersecting) {
      fetchNextPage();
    }
  }, [isIntersecting]);

  if (groupChatListData?.total === 0) {
    return (
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          height: 300px;
        `}
      >
        No group chats available. <br /> Please check back later!
      </div>
    );
  }

  return (
    <FlexStack
      css={css`
        max-height: calc(100dvh - 160px);
        overflow-y: auto;
      `}
    >
      {groupChatListData?.pages.map(
        ({
          id,
          name,
          description,
          language,
          participants_num,
          max_participants_num,
          room_type,
          characters,
        }) => (
          <GroupChatItem
            key={id}
            id={id}
            chatTitle={name}
            description={description}
            language={language}
            total={max_participants_num}
            count={participants_num}
            characters={characters}
            type={room_type}
          />
        ),
      )}
      {isFetchingNextPage ? (
        <FlexStack>
          {makeIndexArray(3).map((el) => (
            <GroupChatCard key={el} />
          ))}
        </FlexStack>
      ) : (
        <div ref={ref} />
      )}
    </FlexStack>
  );
}
